// 9fbef606107a605d69c0edbcd8029e5d
import React, { PureComponent } from 'react';
import { Field, reduxForm } from 'redux-form';
import Image from '@tcp/core/src/components/common/atoms/Image';
import TextBox from '@tcp/core/src/components/common/atoms/TextBox';
import Button from '@tcp/core/src/components/common/atoms/Button';
import BodyCopy from '@tcp/core/src/components/common/atoms/BodyCopy';
import withStyles from '@tcp/core/src/components/common/hoc/withStyles';
import { getLocalStorage } from '@tcp/core/src/utils/localStorageManagement';
import { getIconPath } from '@tcp/core/src/utils';
import createValidateMethod from '@tcp/core/src/utils/formValidation/createValidateMethod';
import getStandardConfig from '@tcp/core/src/utils/formValidation/validatorStandardConfig';
import styles from '../styles/AddPickUpPerson.style';
import Col from '../../../../../../common/atoms/Col';
import Row from '../../../../../../common/atoms/Row';
import {
  getDynamicLabelValues,
  getLabelFromCopyOrFromTranslation,
  getLabelWithDefaultValue,
  renderLabel,
} from '../../../../../../../utils/labels/labelUtilty';
import {
  GLOBAL_ACTIONS_LABELS,
  GlobalActionsLabels,
  lblBack,
  lblSubmit,
} from '../../../../../../../utils/labels/globalActions.labels';
import InformationHeaderView from '../organisms/InformationHeader.view';
import CustomerServiceHelpView from '../../../../CustomerHelp/organisms/TellUsMore/organisms/CustomerServiceHelp/views/CustomerServiceHelp.view';
import {
  GLOBAL_HELPCENTER_LABELS,
  GlobalHelpCenterLabels,
  lblContactUsDirectly,
  lblPickupDisabledEnding,
  lblPickUpDisabledInitial,
  lblTellUsMoreAbtOrder,
} from '../../../../../../../utils/labels/globalHelpCenter.labels';
import {
  ACCOUNT_ORDERS_LABEL,
  lblHelpAnotherOrder,
  OrderDetailLabels,
} from '../../../container/OrderDetails.labels';

class AddPickUpPersonForm extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      showInfoContainer: false,
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps?.showErrorMessageState !== this.props?.showErrorMessageState) {
      window?.scrollTo(0, 0);
    }
  }

  componentWillUnmount() {
    const { resetStateAction } = this.props;
    resetStateAction();
  }

  getLastSegmentFromUrl(url) {
    const regex = /add-pickup\/(\d+)/;
    const match = url?.match(regex);
    return match ? match[1] : null;
  }

  checkUrl = (key) => {
    if (typeof window !== 'undefined') {
      const url = window?.location?.href;
      if (url.includes(key)) {
        return true;
      }
      return false;
    }
    return null;
  };

  submitForm = (formObject) => {
    const { addPickUpPersonAction, orderDetailsData } = this.props;
    const { emailAddress = '', firstName = '', lastName = '' } = formObject;
    const {
      orderNumber,
      emailAddress: orderEmail,
      checkout,
      encryptedEmailAddress,
    } = orderDetailsData;
    const { pickUpStore: { basicInfo: { id } = {} } = {} } = checkout || {};
    const pickUpValueSS = getLocalStorage('PICKUP_DATA');
    const parsedData = pickUpValueSS && JSON.parse(pickUpValueSS);
    const {
      basicInfo: { id: storeIDSS },
      orderEmail: orderEmailSS,
      encryptedEmailAddress: orderEncryptedEmailAddress,
    } = parsedData || {};
    const fromOrderList = this.checkUrl('fromOrderList');

    let orderNumberFromUrl;
    if (window) {
      orderNumberFromUrl = this.getLastSegmentFromUrl(window?.location?.href);
    }
    const fromTrackOrder = this.checkUrl('track-order');
    const orderNo = orderNumber || orderNumberFromUrl;
    const payload = {
      orderId: fromOrderList ? orderNumberFromUrl : orderNo,
      emailId: orderEmail || orderEmailSS,
      pickupPerson: {
        firstName,
        lastName,
        email: emailAddress,
      },
      storeId: id || storeIDSS,
      encryptedEmailAddress: encryptedEmailAddress || orderEncryptedEmailAddress,
      fromTrackOrder,
    };
    addPickUpPersonAction(payload);
  };

  naviagateBack = () => {
    window.history.back();
  };

  getURLParams = () => {
    let orderNumberFromUrl;
    let isFromOrderList;
    if (typeof window !== 'undefined') {
      orderNumberFromUrl = this.getLastSegmentFromUrl(window?.location?.href);
      isFromOrderList = this.checkUrl('fromOrderList');
    }
    return { orderNumberFromUrl, isFromOrderList };
  };

  getHelpMessageLabel = (helpLabels) => {
    return (
      <>
        {getLabelWithDefaultValue(helpLabels, lblPickUpDisabledInitial)}
        &nbsp;
        {getLabelWithDefaultValue(helpLabels, lblContactUsDirectly)}
        &nbsp;
        {getLabelWithDefaultValue(helpLabels, lblPickupDisabledEnding)}
      </>
    );
  };

  render() {
    const {
      handleSubmit,
      className,
      orderDetailsData,
      errorMessage,
      errorState,
      loader,
      showErrorMessageAction,
      altPickupPersonLimit,
      showErrorMessageState,
      ordersList,
      selectOrderAction,
    } = this.props;
    const pickUpValueSS = getLocalStorage('PICKUP_DATA');
    const helpLabels = getLabelFromCopyOrFromTranslation(
      GLOBAL_HELPCENTER_LABELS,
      GlobalHelpCenterLabels
    );
    const ordersLabel = getLabelFromCopyOrFromTranslation(ACCOUNT_ORDERS_LABEL, OrderDetailLabels);

    const { checkout } = orderDetailsData || {};
    const { pickUpStore } = checkout || {};
    const addPickUpPersonLabels = getDynamicLabelValues('dynamic.account_d');
    const headingLabel = addPickUpPersonLabels?.lbl_addPickup;
    const { orderNumberFromUrl, isFromOrderList } = this.getURLParams();
    const order = ordersList?.find((data) => data.orderNumber === orderNumberFromUrl);
    const { orderSummary } = order || {};
    const { pickUpStore: pickUpStoreOrderList } = orderSummary || {};
    const pickUpStoreData =
      (isFromOrderList ? pickUpStoreOrderList : pickUpStore) ||
      (pickUpValueSS && JSON.parse(pickUpValueSS)) ||
      {};
    const { altPickUpPersons, pickUpPrimary } = pickUpStoreData;
    const storeData = {
      storeName: pickUpStoreData?.basicInfo?.storeName?.toLowerCase(),
      city: pickUpStoreData?.basicInfo?.address?.city?.toLowerCase(),
      state: pickUpStoreData?.basicInfo?.address?.state,
      primaryPerson: `${pickUpPrimary?.firstName} ${pickUpPrimary?.lastName}`,
    };
    const infoIcon = getIconPath('info-icon');

    return (
      <div className={className}>
        {showErrorMessageState && (
          <InformationHeaderView
            errorMessage={errorMessage}
            closeAction={showErrorMessageAction}
            errorState={errorState}
          />
        )}
        <button onClick={this.naviagateBack} className="back-anchor-style">
          <span className="left-arrow"> </span>
          {renderLabel(
            getLabelFromCopyOrFromTranslation(
              `${GLOBAL_ACTIONS_LABELS}.${lblBack}`,
              GlobalActionsLabels
            ),
            'lbl_back'
          )}
        </button>
        <div className="form-container">
          <div className="header-section">
            <BodyCopy
              component="div"
              fontFamily="secondary"
              fontWeight="extrabold"
              fontSize="fs28"
              textAlign="center"
            >
              {`${headingLabel?.substring(0, 3)} a ${headingLabel?.substring(3)}`}
            </BodyCopy>
          </div>
          <div className="store-details-section">
            <span className="store-location-section">
              <BodyCopy
                component="span"
                fontFamily="secondary"
                fontWeight="normal"
                fontSize={['fs14', 'fs15']}
              >
                {'Pick-Up at '}
              </BodyCopy>
              {storeData?.storeName && (
                <BodyCopy
                  component="span"
                  fontFamily="secondary"
                  fontWeight="bold"
                  fontSize={['fs14', 'fs15']}
                  className="capitalize-text"
                  textAlign="center"
                >
                  {`${storeData.storeName}, ${storeData.city}, ${storeData.state}`}
                </BodyCopy>
              )}
            </span>
            <span className="store-location-section">
              <BodyCopy
                component="span"
                fontFamily="secondary"
                fontWeight="normal"
                fontSize={['fs14', 'fs15']}
              >
                {addPickUpPersonLabels?.lbl_addPickup_pickup_persons}
              </BodyCopy>
              {pickUpPrimary?.firstName && (
                <BodyCopy
                  component="span"
                  fontFamily="secondary"
                  fontWeight="bold"
                  fontSize={['fs14', 'fs15']}
                  className="capitalize-text"
                >
                  {`${storeData?.primaryPerson}${
                    altPickUpPersons?.length !== 0 ? ',' : ''
                  } ${altPickUpPersons?.map((data) => data.fullName)}`}
                </BodyCopy>
              )}
            </span>
          </div>
          <BodyCopy
            component="div"
            fontFamily="secondary"
            fontWeight="semibold"
            fontSize={['fs12', 'fs15']}
            textAlign="center"
          >
            {addPickUpPersonLabels?.lbl_addPickup_alternate_person_text?.replace(
              'X',
              altPickupPersonLimit
            )}
          </BodyCopy>
          <BodyCopy component="div" textAlign="center" className="underline" />
          <form onSubmit={handleSubmit(this.submitForm)}>
            <div className="emailform__content">
              <Row fullBleed>
                <Col
                  ignoreGutter={{ small: true, medium: true, large: true }}
                  colSize={{ small: 6, medium: 8, large: 12 }}
                >
                  <Field
                    placeholder={'First Name'}
                    name="firstName"
                    id={`firstName`}
                    component={TextBox}
                    dataLocator="first-name-field"
                    className="elem-mb-MED elem-mt-XS"
                    enableSuccessCheck={false}
                    spc
                    autoFocus
                  />
                </Col>
              </Row>
              <Row fullBleed>
                <Col colSize={{ small: 6, medium: 8, large: 12 }}>
                  <Field
                    placeholder={'Last Name'}
                    name="lastName"
                    id={`lastName`}
                    component={TextBox}
                    dataLocator="last-name-field"
                    className="elem-mb-MED"
                    enableSuccessCheck={false}
                    spc
                  />
                </Col>
              </Row>
              <Row fullBleed>
                <Col colSize={{ small: 6, medium: 8, large: 12 }}>
                  <Field
                    placeholder={'Email'}
                    name="emailAddress"
                    id={`emailAddress`}
                    component={TextBox}
                    dataLocator="email-address-field"
                    enableSuccessCheck={false}
                    autocomplete="email"
                    spc
                    isRequired
                  />
                </Col>
              </Row>
              <BodyCopy
                component="div"
                fontFamily="secondary"
                fontWeight="regular"
                fontSize="fs12"
                className="elem-mb-MED"
              >
                {addPickUpPersonLabels?.lbl_addPickup_alternate_person_email_copy}
              </BodyCopy>
              <Button
                fullWidth
                buttonVariation="fixed-width"
                fill="BLUE"
                type="submit"
                className="submit-button elem-mt-MED"
                loading={loader}
              >
                {renderLabel(
                  getLabelFromCopyOrFromTranslation(
                    `${GLOBAL_ACTIONS_LABELS}.${lblSubmit}`,
                    GlobalActionsLabels
                  ),
                  'lbl_submit'
                )}
              </Button>
            </div>
          </form>
        </div>
        <div className="footer-section">
          <BodyCopy
            component="p"
            fontWeight="bold"
            fontFamily="secondary"
            fontSize="fs16"
            className="tell-us-more"
          >
            {getLabelWithDefaultValue(helpLabels, lblTellUsMoreAbtOrder)}
          </BodyCopy>
          <span className="footer-text">
            <Image width="26px" height="26px" src={infoIcon} alt="" className="elem-pr-XS" />
            <BodyCopy
              component="span"
              fontWeight="semibold"
              fontFamily="secondary"
              fontSize="fs16"
              className="tell-us-more"
            >
              {this.getHelpMessageLabel(helpLabels)}
            </BodyCopy>
          </span>
          <CustomerServiceHelpView isNonOnlineOrOlderOrder showReturnPolicy />
          <Button
            className="footer-button "
            fontSize="fs14"
            fontWeight="extrabold"
            buttonVariation="variable-width"
            fill="WHITE"
            onClick={selectOrderAction}
          >
            {getLabelWithDefaultValue(ordersLabel, lblHelpAnotherOrder)}
          </Button>
        </div>
      </div>
    );
  }
}

const validateMethod = createValidateMethod(
  getStandardConfig(['firstName', 'lastName', 'emailAddress'])
);

export default withStyles(
  reduxForm({
    form: 'AddPickUpPersonForm',
    enableReinitialize: true,
    ...validateMethod,
  })(AddPickUpPersonForm),
  styles
);

export { AddPickUpPersonForm as AddPickUpPersonFormVanilla };
